import styled, { css } from 'styled-components';

import * as Base from './styled.default';

//using this to override styles that apply to PLK.

const offerStyles = css`
  ${Styles.desktop`
    width: 100%;
  `}
  margin: 0.5rem auto;
  flex-direction: column;
  background-color: ${Styles.color.cardBackground};

  @media screen and (min-width: 366px) {
    width: 100%;
  }
`;

export const OfferPlaceholder = styled.div`
  ${offerStyles}
`;

export const OffersList = styled(Base.OffersList)`
  padding: 0 0.5rem 2rem;

  ${Styles.desktop`
    padding: 0 0.5rem 1.5rem;
  `}
`;

export const StyledOffer = styled(Base.StyledOffer)`
  ${offerStyles}
`;

export * from './styled.default';
